import { DataSource, Layout, LayoutHeader, Panel, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutSystemHealth extends Layout {
    layoutheaderSystemHealth: LayoutHeader;
    panelMainContent: Panel;
    sourceSystemHealth: DataSource;
    sourceSystemHealthAlerts: DataSource;
    sourceSystemHealthDetails: DataSource;
    tabAlerts: Tab;
    tabDetailedStatus: Tab;
    tabFullStatus: Tab;
    tableAlerts: Table;
    tableSystemHealth: Table;
    tableSystemItems: Table;
    tabsetSystemHealth: Tabset;
}
